export default __webpack_public_path__ + "static/media/NONBINARIO_ICONA.9cbfb8cd.svg";